import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useRef, useState } from "preact/hooks";
import { t, translate } from "../../I18n";
import FulfillmentMethodSwitcher from "./FulfillmentMethodSwitcher";
import FulfillmentAddressModal from "./FulfillmentAddressModal";
import FulfillmentTimeModal from "./FulfillmentTimeModal";
import PreactModal from "../../components/PreactModal";
import RestaurantDeliveryAddressWarning from "../../components/RestaurantDeliveryAddressWarning";
function FulfillmentSettings(props) {
    const { orderDetails, fulfillmentMethodsOptions, fulfillmentMethodController, fulfillmentTimeController, openingHour, isFrame, } = props;
    // TODO: handle it in the Client (Online / QrWaiter OrderDetails?)
    if (orderDetails.fulfillmentTime.type == "QrWaiter" ||
        orderDetails.fulfillmentMethodAddress === null) {
        return null;
    }
    const fulfillmentWidgetExtraClass = isFrame
        ? "m-fulfillment-widget--frame"
        : "";
    return (h(Fragment, null,
        h("article", { id: "fulfillment-settings", class: `m-fulfillment-widget ${fulfillmentWidgetExtraClass}` },
            h("div", { class: "m-fulfillment-widget__method" }, fulfillmentMethodsOptions.length === 1 ? (h(AddressButton, { isDelivery: orderDetails.isDelivery, isSingleFulfillmentMethod: true, singleBtnText: fulfillmentMethodsOptions[0].label, restaurantName: orderDetails.restaurantName, address: orderDetails.fulfillmentMethodAddress, controller: fulfillmentMethodController, deliveryAddressStatus: orderDetails.deliveryAddressStatus })) : (h(FulfillmentMethodSwitcher, { options: fulfillmentMethodsOptions, controller: fulfillmentMethodController.fields.fulfillmentMethod, isFrame: isFrame }))),
            h("div", { className: "m-fulfillment-widget__address d-flex" },
                h(AddressButton, { isDelivery: orderDetails.isDelivery, isSingleFulfillmentMethod: false, restaurantName: orderDetails.restaurantName, address: orderDetails.fulfillmentMethodAddress, controller: fulfillmentMethodController, deliveryAddressStatus: orderDetails.deliveryAddressStatus })),
            h("div", { className: "m-fulfillment-widget__time d-flex" },
                h(TimeButton, { fulfillmentTime: orderDetails.fulfillmentTime, controller: fulfillmentTimeController, openingHour: openingHour }))),
        orderDetails.isDelivery && (h(RestaurantDeliveryAddressWarning, { status: orderDetails.deliveryAddressStatus, isPostCodeRequired: false }))));
}
const restoreFocus = (elementToFocus) => {
    elementToFocus.current && elementToFocus.current.focus();
};
const AddressButton = observer((props) => {
    const { isDelivery, isSingleFulfillmentMethod, singleBtnText, restaurantName, address, controller, deliveryAddressStatus, } = props;
    const addressBtnRef = useRef(null);
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [isRestaurantModalOpen, setIsRestaurantModalOpen] = useState(false);
    const addressString = `${address.firstLine} ${address.secondLine}`;
    const handleOpen = () => {
        if (isDelivery) {
            setIsAddressModalOpen(true);
        }
        else {
            setIsRestaurantModalOpen(true);
        }
    };
    const handleSubmit = () => {
        // TODO: save data from form on submit
        setIsAddressModalOpen(false);
    };
    return (h(Fragment, null,
        isSingleFulfillmentMethod ? (h("button", { type: "button", ref: addressBtnRef, class: "btn btn-primary u-full-width u-full-height", "aria-label": translate(t.order.delivery_address), onClick: handleOpen }, singleBtnText)) : (h("button", { type: "button", ref: addressBtnRef, class: "m-fulfillment-widget__btn u-full-width", "aria-label": translate(t.order.delivery_address), onClick: handleOpen },
            h("span", { class: "m-fulfillment-widget__btn-icon icon-location", "aria-hidden": "true" }),
            h("span", { class: "m-fulfillment-widget__btn-text" }, !(addressString.trim().length === 0)
                ? addressString
                : translate(t.delivery_address.enter_address)))),
        h(FulfillmentAddressModal, { isOpen: isAddressModalOpen, controller: controller, deliveryAddressStatus: deliveryAddressStatus, onSubmit: handleSubmit, onShown: () => setIsAddressModalOpen(true), onHidden: () => {
                setIsAddressModalOpen(false);
                restoreFocus(addressBtnRef);
            } }),
        h(RestaurantModal, { title: restaurantName, address: addressString, isOpen: isRestaurantModalOpen, onShown: () => setIsRestaurantModalOpen(true), onHidden: () => {
                setIsRestaurantModalOpen(false);
                restoreFocus(addressBtnRef);
            } })));
});
const TimeButton = observer((props) => {
    var _a;
    const { fulfillmentTime, controller, openingHour } = props;
    const timeBtnRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleSubmit = () => {
        // TODO: save data from form on submit
        setIsModalOpen(false);
    };
    return (h(Fragment, null,
        h("button", { type: "button", ref: timeBtnRef, class: "m-fulfillment-widget__btn u-full-width", "aria-label": translate(t.order.delivery_time), onClick: () => setIsModalOpen(true) },
            h("span", { class: "m-fulfillment-widget__btn-icon icon-time", "aria-hidden": "true" }),
            h("span", { class: "m-fulfillment-widget__btn-text u-text-capitalize" }, (_a = fulfillmentTime.hourValue) !== null && _a !== void 0 ? _a : translate(t.theme_defaults.hours.now))),
        h(FulfillmentTimeModal, { isOpen: isModalOpen, fulfillmentTime: fulfillmentTime, controller: controller, openingHour: openingHour, onSubmit: handleSubmit, onShown: () => setIsModalOpen(true), onHidden: () => {
                setIsModalOpen(false);
                restoreFocus(timeBtnRef);
            } })));
});
const RestaurantModal = observer((props) => {
    const { title, address, isOpen, onShown, onHidden } = props;
    // TODO: Do translated routing mechanism
    const contactLink = `/kontakt`;
    return (h(PreactModal, { id: "restaurant-info", isOpen: isOpen, onShown: onShown, onHidden: onHidden },
        h("div", { class: "modal-header" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "close", "aria-label": translate(t.generic.close) },
                h("span", { "aria-hidden": "true", class: "icon-cancel" })),
            h("h4", { class: "modal-title" }, title)),
        h("div", { class: "modal-body" },
            h("p", null, address),
            h("a", { href: contactLink }, translate(t.theme_defaults.contact.title))),
        h("div", { class: "modal-footer modal-footer--sticky" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "btn btn-primary btn-block" }, translate(t.theme_defaults.creator.back_to_menu)))));
});
export default observer(FulfillmentSettings);
